import React from "react";
import MuiSkeleton, { SkeletonProps } from "@mui/material/Skeleton";

export const Skeleton: React.FC<SkeletonProps> = (props) => {
  return <MuiSkeleton {...props} />;
};
